export const BRANDING_TILES = {
  LOGO: {
    ACTION_TEXT: 'Upload Image',
    SUBTEXT: 'SVG, PNG, JPG (max. 10MB)',
    TITLE: 'logo',
  },
  PHOTOS: {
    ACTION_TEXT: 'Upload Images',
    SUBTEXT: 'No photos yet',
    TITLE: 'photos',
  },
  BRAND_COLOR: {
    ACTION_TEXT: 'Select Color',
    SUBTEXT: 'No color set',
    TITLE: 'brand color',
  },
};
